<template>
  <el-container style="height: 86vh">
    <Sidebar :list="treeData" ref="sidebar" />
    <el-container>
      <el-main>
        <appMain />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Sidebar from '@/components/AppMainSidebar'; // 侧边栏
import appMain from './components/appMain'; // 侧边栏
import { getPageTreeApi } from '@/api/areaApi';

export default {
  name: 'Banner',
  components: {
    Sidebar,
    appMain,
  },
  data() {
    return {
      treeData: [],
    };
  },
  created() {
    this.getAreaList();
  },
  methods: {
    async getAreaList() {
      try {
        let res = await getPageTreeApi();
        this.treeData = res.data.treeData;
        this.$refs.sidebar.expandedList = [
          res.data.treeData[0] && res.data.treeData[0].areaId,
        ];
        // console.log('treeData', res.data.treeData);
        this.$store.dispatch('area/setAreaAllList', this.treeData);
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
